import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class SSOMappingsService {

  static getAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}roles/sso/mapping`).then((data) => {
        resolve({ mappings: data.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }


  static save(mappings) {
    return new Promise((resolve, reject) => {
      axios.put(`${ROOT}roles/sso/mapping`, mappings).then((data) => {
        resolve({ mappings: data.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static runTest(nameToTest, roleTypeId, expression) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}roles/sso/mapping/test?mappingExpression=${encodeURIComponent(expression)}&testName=${nameToTest}&roleTypeId=${roleTypeId}`).then((data) => {
        resolve({ roles: data.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default SSOMappingsService;
